// extracted by mini-css-extract-plugin
export var fieldset = "FilterSelect-module--fieldset--V0f4A";